import { render, staticRenderFns } from "./ProductApplicationView.vue?vue&type=template&id=5cb48a93&scoped=true"
import script from "./ProductApplicationView.vue?vue&type=script&lang=js"
export * from "./ProductApplicationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb48a93",
  null
  
)

export default component.exports